import { useState, useEffect } from "react";
import {
IonImg,
IonText,
IonIcon,
IonAccordion,
IonAccordionGroup,
IonButton,
IonItem,
IonLabel,
IonList
} from "@ionic/react";
import {
caretDownOutline, 
briefcaseSharp,
menuSharp, 
personSharp,
personAddSharp,
carSharp
} from "ionicons/icons"

import './Header.css'


// Navigation Option Data
const navigationOptionsData = [
    {
        icon: personSharp,
        title: 'Login',
        route: 'login',
        ext: false,
        customIcon: false
    },
    {
        icon: personAddSharp,
        title: 'Sign Up',
        route: 'signup',
        ext: false,
        customIcon: false
    },
    {
        icon: 'icon/support_icon.png',
        title: 'Support',
        route: 'https://help.rydesharing.com/hc/en-us/requests/new',
        ext: true,
        customIcon: true
    },
    {
        icon: carSharp,
        title: 'Become A Driver',
        route: 'https://www.rydesharing.com/downloaddriver/?_branch_match_id=1062903574791878212&_branch_referrer=H4sIAAAAAAAAA8soKSkottLXL6pMSU0pyixLLdJLLCjQy8nMy9aH8AFYJyOxIgAAAA%3D%3D',
        ext: true,
        customIcon: false
    },
]

const Header = (history) => {

    const [innerWidth, setInnerWidth] = useState(window.innerWidth);
    const [backdropOpen, setBackdropOpen] = useState(false);

    useEffect(() => {
        window.addEventListener(
        "resize",
        () => {
            setInnerWidth(window.innerWidth);
        },
        { passive: true }
        );
    }, []);
        return (
        <div
        style={{
            backgroundColor: "#ea3364",
            width: "100%",
            height: "78px",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
        }}
        >
        <div
            style={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "flex-start",
            padding: "20px",
            maxWidth: "1200px",
            width: "100%",
            margin: "0 auto",
            }}
        >
            <IonImg 
            style={{
                height: '45px',
                width: '90px'
            }}
            src="logo/rydelogowhite.svg" />
            <div style={{
                'display': 'flex',
                flexDirection: 'row',
                justifyContent: 'space-around'
            }}></div>
            <div
            style={{
                display: "flex",
                alignItems: "start",
                position: "absolute",
                top: "1%",
                right: "1%",
            }}
            >
            {innerWidth > 661 ? (
                <>
                {navigationOptionsData
                    .slice(2, navigationOptionsData.length + 1)
                    .map((option, index) => {
                    return (
                        <div
                        className="navLink"
                        key={index}
                        style={{
                            paddingInline: "10px",
                            marginTop: "16px",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            minWidth: "130px",
                            color: "#fff",
                        }}
                        onClick={() => {
                            option.ext
                            ? window.open(option.route, "_blank")
                            : history.push(`/${option.route}`);
                        }}
                        >
                        <IonText
                            className="font-m font-baloo font-semibold"
                            style={{
                            fontSize: "1rem",
                            }}
                        >
                            {option.title}
                        </IonText>
                        </div>
                    );
                    })}
                {Popover(navigationOptionsData.slice(0, 2),history)}
                </>
            ) : (
                <>
                <div
                    style={{
                    marginInlineEnd: "10px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    }}
                    onClick={() => setBackdropOpen(true)}
                >
                    <IonIcon
                    icon={menuSharp}
                    style={{
                        fontSize: "3rem",
                        color: "white",
                        paddingBlock: "5px",
                    }}
                    />
                </div>
                {backdropOpen ? backdropNavOptions(setBackdropOpen,history) : null}
                </>
            )}
            </div>
        </div>
        </div>
    );
    };
    // Functional Component for Popover
    const Popover = (data,history) => {
    return (
        <div style={{"margin-top":"4px"}}>
        
            <IonAccordionGroup>
            <IonAccordion value="menu" toggleIcon={null}>
                <IonItem
                slot="header"
                style={{
                    
                    "--background": "#e93864",
                    "--color": "#fff",
                }}
                >
                <IonIcon
                    slot="end"
                    className="ion-accordion-toggle-icon"
                    icon={caretDownOutline}
                    style={{
                    color: "#fff",
                    }}
                />
                <IonLabel
                    style={{
                    paddingBlock: "2px",
                    display: "flex",
                    flexDirection: "row",
                    alignItems: "center",
                    justifyContent: "center",
                    paddingInlineStart: "5px",
                    }}
                >
                    {/* <IonIcon
                    style={{
                        color: "#fff",
                    }}
                    icon={briefcaseSharp}
                    />
                    &nbsp; */}
                    <IonLabel
                    className="font-m font-baloo font-semibold"
                    style={{
                        // fontWeight:'500',
                        color: "#fff",
                        paddingInlineStart: "5px",
                    }}
                    >
                    RydeSEND Portal
                    </IonLabel>
                </IonLabel>
                </IonItem>
                <IonList
                slot="content"
                style={{
                    paddingBlock: "0px",
                    paddingBottom: "5px",
                }}
                >
                {data.map((item, index) => {
                    return (
                    <IonItem
                        className="hover"
                        key={index}
                        onClick={() => {
                        item.ext
                            ? window.open(item.route, "_blank")
                            : history.push(`/${item.route}`);
                        }}
                    >
                        <IonLabel
                        style={{
                            paddingBlock: "2px",
                            paddingInlineStart: "15px",
                        }}
                        >
                        {!item.customIcon ? (
                            <IonIcon
                            style={{
                                color: "#e93864",
                            }}
                            icon={item.icon}
                            />
                        ) : (
                            <IonImg
                            src={item.icon}
                            style={{
                                color: "#e93864",
                                width: "1em",
                                height: "1em",
                            }}
                            />
                        )}
                        &nbsp;
                        <IonText
                            className="font-m font-baloo font-semibold"
                            style={{
                            color: "#e93864",
                            paddingInlineStart: "5px",
                            }}
                        >
                            {item.title}
                        </IonText>
                        </IonLabel>
                    </IonItem>
                    );
                })}
                </IonList>
            </IonAccordion>
            </IonAccordionGroup>
       
        </div>
    );
    };

    // Functional Component for backdropNavOptions
    const backdropNavOptions = (setBackdropOpen,history) => {
    return (
        <>
        <div
            style={{
            zIndex: "1000",
            position: "fixed",
            height: "100vh",
            width: "100vw",
            top: "0",
            left: "0",
            backgroundColor: "rgba(0,0,0,0.5)",
            }}
            onClick={() => setBackdropOpen(false)}
        />
        <div
            style={{
            zIndex: "1001",
            position: "fixed",
            top: "2%",
            right: "3%",
            borderRadius: "10px",
            }}
        >
            {
            <IonList
                slot="content"
                style={{
                paddingBlock: "0px",
                paddingBottom: "5px",
                paddingInline: "0px",
                borderRadius: "10px",
                }}
            >
                {navigationOptionsData.map((item, index) => {
                return (
                    <IonItem
                    className="hover"
                    key={index}
                    onClick={() => {
                        item.ext
                        ? window.open(item.route, "_blank")
                        : history.push(`/${item.route}`);
                    }}
                    >
                    <IonLabel
                        style={{
                        paddingBlock: "2px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "flex-start",
                        }}
                    >
                        {!item.customIcon ? (
                        <IonIcon
                            style={{
                            color: "#e93864",
                            }}
                            icon={item.icon}
                        />
                        ) : (
                        <IonImg
                            src={item.icon}
                            style={{
                            color: "#e93864",
                            width: "1em",
                            height: "1em",
                            }}
                        />
                        )}
                        &nbsp;
                        <IonText
                        style={{
                            fontWeight: "500",
                            color: "#e93864",
                            paddingInline: "10px",
                        }}
                        >
                        {item.title}
                        </IonText>
                    </IonLabel>
                    </IonItem>
                );
                })}
            </IonList>
            }
        </div>
        </>
    );
};

export default Header;
